export default __webpack_public_path__ + "static/media/wakeup.1174e9ec.png";